<template>
  <div class="partner-section">
    <a href="https://builders.mozilla.community/">
      <img
        src="/img/mozilla-builders-logo.png"
        alt=""
      >
      <span :class="labelClasses">Mozilla Builders Incubator</span>
    </a>

    <a href="https://techcrunch.com/2019/10/17/microsoft-accessibility-grants-go-out-to-companies-aiming-to-improve-tech-for-the-disabled/">
      <img
        src="/img/microsoft-logo.png"
        alt=""
      >
      <span :class="labelClasses">Microsoft AI for Accessibility Grant</span>
    </a>
    <a href="https://theforge.mcmaster.ca/">
      <img
        src="/img/forge-logo.jpeg"
        alt=""
      >
      <span :class="labelClasses">The Forge Startup Incubator</span>
    </a>
  </div>
</template>

<script>
export default {
  name: 'PartnerLogos',
  components: {},
  props: {
    labelClasses: {
      default: '',
      type: String
    }
  },
  data () {
    return {}
  },
  computed: {},
  watch: {},
  methods: {}
}
</script>
<style scoped>
    .partner-section img {
        max-width: 300px;
        margin-bottom: 12px;
    }

    .partner-section {
        display: flex;
        flex-wrap: wrap;
        gap: 30px;
        justify-content: center;
        align-items: center;
    }

    .partner-section a {
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
</style>
